<template>
  <div class="animated fadeInDown" :class="['top']">
    <div class="search-search" :class="[searchListBool?'ac':'']" @mouseenter="searchEnter" @mouseleave="searchLeave">
      <span class="icon-img icon-search"></span>
      <input :class="[searchKeyValClass]" type="text" v-model.trim="searchKeyVal"
             @input="searchInput"
             @compositionstart="compositionstart"
             @compositionend="compositionend"
             placeholder="搜索关键字"
      >
      <span v-if="searchKeyVal" class="icon-img icon-clear" @click="clearSearchVal"></span>
      <template v-if="searchListBool&&searchLists&&searchLists.length">
        <div class="search-result">
          <div class="max-con">
            <template v-for="(item,searchIndex) in searchLists">
              <div class="search-result-list" :key="'searchLists'+searchIndex" @click="searchMap(searchIndex)">
                <p class="oneRow">{{item.name}}</p>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <div class="top-tabs">
      <div class="swiper-container container-top-map">
        <div class="swiper-wrapper">
          <template v-if="lists&&lists.length">
            <div class="swiper-slide" :class="[(parameter.typeId==0?'active':'')]">
              <div @click="tabClick(-1,0)">
                <p>全部</p>
                <template v-if="parameter.typeId==0"><span></span></template>
              </div>
            </div>
            <template v-for="(list,index) in lists">
              <div class="swiper-slide" :class="[(parameter.typeId==list.id?'active':'')]" :key="'top'+index">
                <div :key="'top'+index" @click="tabClick(index,list.id)">
                  <p>{{list.name}}</p>
                  <template v-if="parameter.typeId==list.id"><span></span></template>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="search-address" :class="selectAddress" @mouseleave="leaveFun">
      <div class="search-address-name oneRow" @mouseover="addressFun" @click="addressShowHide">{{addressCity.name || ($realmNameId==50?'重庆市':'四川省')}}<i class="icon-img"></i></div>
      <div class="search-address-list">
        <div class="search-address-list-center">
          <ul :class="addressSearchClass">
            <template v-if="addressBtn&&addressBtn.length" v-for="(item, index) in addressBtn">
              <li :key="'item'+index" :class="[tabIndex==index?'active':'']" @click="tabAddress(index)">
                <div>{{item}}</div>
              </li>
            </template>
            <li>
              <div class="address-search">
                <span class="icon-img icon-search" @click="addressSearch"></span>
                <div class="address-search-input"
                     @mouseenter="searchEnter1"
                     @mouseleave="searchLeave1">
                  <input type="text"
                         v-model="addressVal"
                         placeholder="请输入地名"
                         @input="searchInput1"
                         @compositionstart="compositionstart1"
                         @compositionend="compositionend1"
                  />
                  <span class="icon-img icon-search-close" @click="searchClose"></span>
                  <template v-if="addressVal&&addressListBool">
                    <div class="address-search-input-list">
                      <div class="max-con">
                        <template v-if="addressSearchList&&addressSearchList.length">
                          <template v-for="(list,index) in addressSearchList">
                            <div class="oneRow address-search-input-list-one" @click="addressMapTo(list.cityId,index)" :key="'addressSearchList'+index">{{list.name}}</div>
                          </template>
                        </template>
                        <template v-else>
                          <div>暂无相关内容</div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <span  class="jump-home" @click="tabClick(0,-1)">{{$realmNameId==50?'重庆':'四川'}}</span>
            </li>
          </ul>
          <div class="address-content">
            <div v-if="tabIndex==0">
              <template v-if="cityData&&cityData.length">
                <template v-for="(city, i) in cityData">
                  <div class="oneRow"
                       @click="cityTo(city)"
                       :title="city.name"
                       :key="'addressIndex'+ i"
                       :class="[city.cityId==parameter.cityId?'active':'',city.state?'':'no-click']">{{city.name}}</div>
                </template>
              </template>
            </div>
            <div v-if="tabIndex==1">
              <template v-if="countyData&&countyData.length">
                <template v-for="(county, i) in countyData">
                  <div @click="countyTo(county.cityId,i,county.state)"
                       class="oneRow"
                       :title="county.name"
                       :class="[parameter.cityId==county.cityId?'active':'',county.state?'':'no-click']"
                       :key="'addressLetterIndex'+i">{{county.name}}</div>
                </template>
              </template>
              <template v-else>
                <div>暂无</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="exitMapBool" class="map-btn" @click="exitMap"><i class="icon-img icon-address"></i>退出地图</div>
    <transition enter-active-class="animated fadeInDown" leave-active-class="animated zoomOut">
      <div v-if="noDataBool" class="no-data-tips">暂无点位信息，请切换到其他{{tipsName}}看一看</div>
    </transition>
  </div>
</template>

<script>
import mapFun from '../common/map.js'
export default {
  props: ['backBool', 'noDataBool', 'mapListClickBool'],
  name: 'topMap',
  data () {
    return {
      lists: [],
      loaded: false,
      addressCity: '',
      addressBtn: ['地级市', '区县级'],
      cityData: [],
      countyData: [],
      addressAllData: [],
      parameter: {
        cityId: 0,
        typeId: 0,
        cityIndex: -1,
        countyIndex: -1
      },
      cityIndex: -1,
      selectAddress: '',
      tabIndex: 0,
      cityTopIndex: -1,
      countyTopIndex: -1,
      topIndexState: 0,
      searchKeyVal: '',
      searchKeyValClass: '',
      searchLists: [],
      searchListBool: true,
      prevState: 0,
      flag: true,
      flag1: true,
      prevCityId: 0,
      prevCountyIndex: -1,
      activeIndex: -1,
      addressVal: '',
      addressSearchClass: '',
      addressListBool: false,
      addressSearchList: [],
      exitMapBool: false,
      addressShowHideBool: true,
      containerTopMap: '',
      tipsName: '',
      industryOnlyData: {},
      mapBool: false,
      oneImplementBool: true // 第一次执行Boolean值
    }
  },
  created () {
    let _that = this;
    if(_that.$realmNameId==50){
      _that.addressBtn=['区县', '乡镇']
    }else {
      _that.addressBtn=['地级市', '区县级']
    }
    let parameter = JSON.parse(_that.publicJs.decode(_that.$route.query)) || {};
    _that.parameter.cityId = parameter.cityId || 0;
    _that.parameter.typeId = parameter.typeId || 0;

    _that.activeIndex = (parameter.topIndex >= 0 ? parameter.topIndex : 0) - 1;

    if (_that.parameter.cityId > 0) {
      _that.prevCityId = _that.parameter.cityId;
      _that.tabIndex=1
    } else {
      _that.parameter.cityIndex = -1
    }
    _that.addressAllDataFun()
    _that.prevState = parameter.state
  },
  mounted () {
    this.exitMapBool = true
    this.searchInput()
  },
  components: {
  },
  methods: {
    searchEnter: function () {
      this.searchListBool = true
    },
    searchLeave: function () {
      this.searchListBool = false
    },
    compositionstart: function () {
      this.flag = false
    },
    compositionend: function () {
      this.flag = true
    },
    searchInput: function () {
      let that = this
      if (that.searchKeyVal) {
        if (that.flag) {
          that.httpAjax.getAjax('PanoWebService.asmx/GetPanoByWhere_Map', {
            page: 1,
            cityId: 0,
            limit: 10000,
            typeId: 0,
            keyWords: that.searchKeyVal
          }).then(function (data) {
            if (data.code === 1) {
              that.searchLists = data.data
            }
          }, function (err) {
            console.log(err)
          })
        }
      } else {
        that.searchLists = []
      }
    },
    searchMap: function (i) {
      mapFun.addressSite(this.searchLists[i])
    },
    tabClick: function (index, typeId) {
      let that = this
      that.tipsName = '行业'
      if (typeId > -1) {
        that.parameter.typeId = typeId;
        let types=that.publicJs.onlyTypeData(that.lists,typeId)
        that.activeIndex = types.index||0;
        that.containerTopMap.slideTo(that.activeIndex > 0 ? that.activeIndex : 0);

        that.industryOnlyData = types
        // that.mapBool = true
        that.$emit('mapBool', true);
        that.$emit('industryCity', that.industryOnlyData, that.addressCity, true, 1)
      } else {
        let b = JSON.parse(that.publicJs.decode(that.$route.query))
        if (b.cityId) {
          let c = that.$router.resolve({
            path: '/'
          })
          window.open(c.href, '_pageHome')
        } else {
          this.$router.push('/')
        }
      }
    },
    httpData: function () {
      let _that = this
      _that.publicJs.navGetData(function (data) {
        if (data.code === 1) {
          _that.lists = _that.lists.concat(data.data)
          _that.industryOnlyData =_that.publicJs.onlyTypeData(_that.lists,_that.parameter.typeId)||{id:0}
          _that.$emit('industryCity', _that.industryOnlyData, _that.addressCity, 1)
          _that.$nextTick(function () {
            _that.swiperFun()
          })
        }
      })
    },
    swiperFun: function () {
      let _that = this;
      _that.$nextTick(function () {
        // eslint-disable-next-line
        _that.containerTopMap = new Swiper('.container-top-map', {
          slidesPerView: 'auto',
          spaceBetween: 104,
          observer: true,
          // observeSlideChildren: true,
          // observeParents: true,
          centerInsufficientSlides: true,
          watchOverflow: true,
          breakpoints: {
            1380: {
              spaceBetween: 60
            },
            1100: {
              spaceBetween: 40
            },
            900: {
              spaceBetween: 30
            },
            800: {
              spaceBetween: 25
            },
            750: {
              spaceBetween: 15
            }
          },
          on: {
            init: function () {
            }
          }
        })
        let c=_that.publicJs.onlyTypeData(_that.lists,_that.parameter.typeId).index;
        _that.containerTopMap.slideTo(c)
      })
    },
    addressAllDataFun: function () {
      let that = this;
      this.publicJs.addressGetData(function (res) {
        if (res.code === 1) {
          that.addressAllData = res.data;
          let cityData = res.data || [];
          that.cityData = cityData;
          if (that.parameter.cityId > 0) {
            let city=that.publicJs.onlyCityData(cityData,that.parameter.cityId);
            if(city.data){
              that.countyData=city.data;
            }else {
              that.countyData=city.child;
            }
            that.addressCity = city || {cityId: 0, name: (that.$realmNameId==50?'重庆':'四川')};
            that.publicJs.changeDocumentTitle(that.addressCity.name,city.cityId);
            // eslint-disable-next-line
            mapinit(that.addressCity.x, that.addressCity.y, that.addressCity.mapLevel,that.$realmNameId)
          } else {

            that.publicJs.changeDocumentTitle(that.$realmNameId==50?'重庆':'四川',0);
            // eslint-disable-next-line
            if(that.$realmNameId==50){
              mapinit(106.54476999183, 29.568610399746, 6,that.$realmNameId)
            }else {
              mapinit(102.55879281894, 31.121115892911, 6,that.$realmNameId)
            }
          }
          that.httpData();
          mapFun.moveMap(function (moveData) {

            if (!that.mapListClickBool) {
              if (that.oneImplementBool) {
                that.$emit('mapBool', true);
                that.$emit('industryCity', that.industryOnlyData, that.addressCity);
                that.oneImplementBool = false
              } else {
                // eslint-disable-next-line
                let mapLevel = MAP.map.getZoom();

                if(moveData.id){
                  return false;
                }
                if (mapLevel <= 6) {
                  that.$emit('industryCity', that.industryOnlyData, {})
                } else {
                  let b = mapFun.moveMapBackCity(res.data, moveData, mapLevel);
                  if (b.cityId !== that.addressCity.cityId) {
                    that.addressCity = b;
                    that.$emit('industryCity', that.industryOnlyData, that.addressCity)
                  }
                }
              }
            }
          })
        }
      })
    },
    addressShowHide: function () {
      let that = this
      if (that.addressShowHideBool) {
        that.addressShowHideBool = false
        that.addressFun()
      } else {
        that.addressShowHideBool = true
        that.leaveFun()
      }
    },
    addressFun: function () {
      let that = this
      that.selectAddress = 'address-active'
    },
    leaveFun: function () {
      let that = this
      that.selectAddress = ''
    },
    countyTo: function (cityId, i) {
      let that = this;
      this.addressVal = '';
      this.addressSearchClass = '';
      this.addressSearchList = [];
      this.addressListBool = false;
      that.countyTopIndex = i;
      that.parameter.countyIndex = i;
      that.parameter.cityId = cityId;

      that.addressCity = that.publicJs.onlyCityData(that.addressAllData,cityId)||{cityId: 0, name: ''};
      that.tipsName = '城市';
      that.$emit('mapBool', true);
      that.$emit('industryCity', that.industryOnlyData, that.addressCity, true, 2);
    },
    addressMapTo: function (cityId, i) {
      let that = this
      let onlyData = that.addressSearchList[i]
      that.cityTopIndex = onlyData.cityIndex
      that.countyTopIndex = onlyData.countyIndex
      that.addressCity = onlyData;
      let city=that.publicJs.onlyCityData(that.addressAllData,cityId)
      if(city.data){
        that.countyData=city.data||[];
      }else {
        that.countyData=city.child||[];
      }

      this.addressVal = '';
      this.addressSearchClass = '';
      this.addressSearchList = [];
      this.addressListBool = false;
      that.parameter.cityId = cityId;
      that.$emit('mapBool', true);
      that.$emit('industryCity', that.industryOnlyData, onlyData, true, 2);
    },
    tabAddress: function (i) {
      this.tabIndex = i
    },
    cityTo: function (city) {
      let that = this;
      that.parameter.cityId = city.cityId;
      that.addressVal = '';
      that.addressSearchClass = '';
      that.addressSearchList = [];
      that.addressListBool = false;
      that.tipsName = '城市';
      let county=that.publicJs.onlyCityData(that.addressAllData,city.cityId);
      that.countyData = county.child||[];

      that.addressCity = county || {cityId: 0, name: ''}

      // that.mapBool = true
      that.$emit('mapBool', true)
      that.$emit('industryCity', that.industryOnlyData, that.addressCity, true, 2)
    },
    exitMap: function () {
      let that = this
      if (that.prevState === 1) {
        let cityId = that.prevCityId;
        let data = {
          path: '/searchPage',
          query: {
            key: that.publicJs.encode(JSON.stringify({
              typeId: 0,
              cityId: that.prevCityId,
            })),
            '_': new Date().getTime()
          }
        }
        if (cityId) {
          let c = that.$router.resolve(data);
          window.open(c.href, '_pageCity' + cityId)
        } else {
          this.$router.push(data)
        }
      } else if (that.prevState === 2) {
        let c = that.$router.resolve({
          path: '/pageCity',
          query: {
            key: that.publicJs.encode(JSON.stringify({
              typeId: 0,
              cityId: that.prevCityId,
            })),
            '_': new Date().getTime()
          }
        })
        window.open(c.href, '_pageCity' + that.prevCityId)
      } else if (that.prevState === 0) {
        that.$router.push({path: '/'})
      }
    },
    addressSearch: function () {
      let that = this
      that.addressSearchClass = 'address-search-active'
    },
    searchEnter1: function () {
      this.addressListBool = true
    },
    searchLeave1: function () {
      this.addressListBool = false
    },
    compositionstart1: function () {
      this.flag1 = false
    },
    compositionend1: function () {
      this.flag1 = true
    },
    searchInput1: function () {
      let that = this
      if (that.addressVal) {
        that.addressSearchList = that.publicJs.fuzzyQuery(that.addressAllData, that.addressVal)
      } else {
        that.addressSearchList = []
      }
    },
    clearSearchVal: function () {
      this.searchKeyVal = ''
      this.searchLists = []
    },
    searchClose: function () {
      this.addressVal = ''
      this.addressSearchClass = ''
      this.addressSearchList = []
      this.addressListBool = false
    }
  },
  watch: {
    state: function (a, b) {
      this.state = a
    },
    parameter: {
      handler: function (a, b) {
      },
      deep: true
    },
    'backBool': function (newData, b) {
      if (newData !== b) {
        /* eslint-disable */
        MAP.map.checkResize();
      }
    },
    '$route': function (newData, b) {
      if (newData !== b) {
        let routeQuery = JSON.parse(this.publicJs.decode(newData.query));
        this.parameter.typeId = routeQuery.typeId || 0;
        this.parameter.cityId = routeQuery.cityId || 0;
        this.parameter.keyWords = routeQuery.keyWords || '';
        this.parameter.topIndex = routeQuery.topIndex || 0;
        this.parameter.cityIndex = routeQuery.cityIndex || 0;
        this.parameter.countyIndex = routeQuery.countyIndex >= 0 ? routeQuery.countyIndex : -1;
        this.tabIndex=(this.parameter.cityId?1:0)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .top{
    position: fixed;
    top:0;
    left: 0;
    right: 0;
    z-index: 100;
    background:#fff;
    border-bottom: 2px solid rgba(255,255,255,0.5);
    padding: 0 120px 0 370px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow:0px 3px 7px 1px rgba(221, 221, 221, 0.56);
    -moz-box-shadow:0px 3px 7px 1px rgba(221, 221, 221, 0.56);
    box-shadow:0px 3px 7px 1px rgba(221, 221, 221, 0.56);
  }
  .search-search{
    position: absolute;
    left: 21px;
    top:22px;
    bottom: 22px;
    width: 338px;
    height: 42px;
    background: #FFFFFF;
    border: 1px solid #CECECE;
    border-radius: 21px;
    padding:0 20px 0 29px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .search-search.ac{
    border-color:#248ddf;
  }
  .search-search>.icon-search{
    width: 14px;
    height: 14px;
    background-position: -460px -885px;
    position: absolute;
    left: 8px;
    top:50%;
    margin-top: -7px;
  }
  .icon-clear{
    position: absolute;
    right: 6px;
    top: 14px;
    background-position: -737px -178px;
    width: 13px;
    height: 12px;
  }
  .icon-clear:hover{
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    -webkit-transition: transform 0.5s;
    -moz-transition: transform 0.5s;
    -ms-transition: transform 0.5s;
    -o-transition: transform 0.5s;
    transition: transform 0.5s;
    background-position: -766px -178px;
  }
  .search-search>input::placeholder{
    color: #8c8e9e;
  }
  .search-search>input{
    font-size: 14px;
    color: #333;
    letter-spacing: 1px;
    display: block;
    height: 40px;
    width: 100%;
  }
  .top-tabs{
    max-width:90%;
    margin: 0 auto;
  }
  .swiper-slide{
    width: auto;
    color: #999999;
  }
  .swiper-slide>div{
    padding: 32px 0;
    font-size: 18px;
  }
  .top-tabs .swiper-slide.active,
  .top-tabs .swiper-slide:hover{
    color: #248DDF;
    position: relative;
  }
  .top-tabs .swiper-slide.active span{
    position: absolute;
    bottom: -1px;
    left:50%;
    margin-left: -20px;
    width: 40px;
    height: 3px;
    background: #248DDF;
    border-radius: 2px;
  }
  .top-tabs .swiper-slide:hover:after{
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width:100%;
    height: 2px;
    background: #248DDF;
    -webkit-animation: yi 0.5s;
    -o-animation: yi 0.5s;
    animation: yi 0.5s;
  }
  @keyframes yi {
    0%{
      width: 0;
    }
    100%{
      width:100%;
    }
  }
  .map-btn{
    position: absolute;
    cursor: pointer;
    right: 20px;
    bottom: -54px;
    width: 110px;
    height: 38px;
    background: #248DDF;
    border-radius: 19px;;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 38px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 20px;
    -webkit-box-shadow: 0 1px 5px  #248DDF;
    -moz-box-shadow: 0 1px 5px  #248DDF;
    box-shadow: 0 1px 5px  #248DDF;
    z-index: 2;
  }
  .map-btn .icon-address{
    width: 12px;
    height: 17px;
    background-position: -512px -884px;
    position: absolute;
    top: 50%;
    left: 15px;
    margin-top: -8.5px;
  }
  .search-address.address-active{
    z-index: 7;
  }
  .search-address{
    position: absolute;
    right:20px;
    top:23px;
  }
  .search-address-name{
    color: #666666;
  }
  .search-address-name i{
    background-position: -553px -891px;
    position: absolute;
    top: 50%;
    right: 4px;
    margin-top: -4px;
  }
  .search-address .search-address-list{
    right: -5px;
    padding-top: 16px;
    top:40px;
  }
  .screen3 .top{
    padding: 0 120px 0 280px;
  }
  .screen3 .search-search {
    width: 260px;
  }
</style>



// WEBPACK FOOTER //
// src/components/topMap.vue